import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import "./Zdroj.css";
import Title from "../../components/Title/Title";

export default function Zdroj() {
    useEffect(() => {
        // Set a 3-second delay before redirecting
        const timer = setTimeout(() => {
            document.querySelector("body").innerHTML = `<img id="číčaspí" src="/číčaspí.webp" style="position: absolute; top: 0px; left: 0px; width: 100%; height: 100%; z-index: 99999;" draggable="false">`;
            setTimeout(() => {
                window.location.replace("https://www.degit.click/ceskastranaasocialu/pages");
            }, 500);
        }, 1000);

        return () => clearTimeout(timer); // Clean up the timer if the component unmounts
    }, []);

    return (
        <div id="sourceContent">
            <Helmet>
                <title>Zdroj · ČSA</title>
                <meta name="description" content="ČSA je recesistická politická strana, jejíž cílem, pokud ti to ještě nedošlo, je naprostá asocializace společnosti a České republiky. Chození ven způsobilo války, neštěstí a zmar, proto tu jsou asociálové, aby vše napravili. HLAVNĚ TO PROBOHA NEBERTE VÁŽNĚ, JSME RECESISTI!" />
                <meta property="og:title" content="Zdroj · ČSA" />
                <meta property="og:description" content="ČSA je recesistická politická strana, jejíž cílem, pokud ti to ještě nedošlo, je naprostá asocializace společnosti a České republiky. Chození ven způsobilo války, neštěstí a zmar, proto tu jsou asociálové, aby vše napravili. HLAVNĚ TO PROBOHA NEBERTE VÁŽNĚ, JSME RECESISTI!" />
                <meta property="og:image" content={`${process.env.PUBLIC_URL}/assets/banner.png`} />
                <meta property="og:url" content="https://www.asocialove.cz/#/path" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Zdroj · ČSA" />
                <meta name="twitter:description" content="ČSA je recesistická politická strana, jejíž cílem, pokud ti to ještě nedošlo, je naprostá asocializace společnosti a České republiky. Chození ven způsobilo války, neštěstí a zmar, proto tu jsou asociálové, aby vše napravili. HLAVNĚ TO PROBOHA NEBERTE VÁŽNĚ, JSME RECESISTI!" />
                <meta name="twitter:image" content={`${process.env.PUBLIC_URL}/assets/banner.png`} />
            </Helmet>
            <Title>Dejte nám sekundu :3</Title>
            <p>Sisina tvrdě spí, a JavaScript pracuje na tom, aby ste se dostali na náš déGit.</p>
        </div>
    );
}
